import { Box } from "@chakra-ui/react";
import CardsList from "@/components/cardsList";
import { SERVICES_CARDS_CONSTANTS } from "./servicesConstants";

const ServicesCards = () => {
  return (
    <Box id="services">
      <CardsList
        list={SERVICES_CARDS_CONSTANTS.list}
        columns={{ base: 1, sm: 2, md: 3 }}
      />
    </Box>
  );
};

export default ServicesCards;
